// Constants
const { GAME_MODES, ALL_MODE_VALUES, getModeByTitle, getSessionType } = require("./src/constants/gameModes");
const { BUTTON_COLORS } = require("./src/constants/buttonColors");
const { SUCCESS_MESSAGES, INCORRECT_MESSAGE } = require("./src/constants/successMessages");
const { SUPPORT_LINKS, SUPPORT_MODAL, GAME_TYPE_MODAL, MODE_SELECTOR, WELCOME_CONTENT } = require("./src/constants/supportContent");
const { REGISTER_FORM, PASSWORD_RULES, USERNAME_RULES, VALIDATION_MESSAGES, validatePassword, validateUsername, isValidEmail, getRegisterErrorMessage } = require("./src/constants/registerContent");

// Utils
const { getRandomPoints, getSuccessMessage, POINT_VALUES } = require("./src/utils/scoring");
const { sortQuestionsById, sortPageQuestions } = require("./src/utils/questions");
const { extractYouTubeId } = require("./src/utils/youtube");

// Service factories
const { createScoreService } = require("./src/services/scoreService");
const { createGameSessionService } = require("./src/services/gameSessionService");
const { createUserAnswerService } = require("./src/services/userAnswerService");

module.exports = {
  // Constants
  GAME_MODES,
  ALL_MODE_VALUES,
  getModeByTitle,
  getSessionType,
  BUTTON_COLORS,
  SUCCESS_MESSAGES,
  INCORRECT_MESSAGE,
  POINT_VALUES,
  SUPPORT_LINKS,
  SUPPORT_MODAL,
  GAME_TYPE_MODAL,
  MODE_SELECTOR,
  WELCOME_CONTENT,
  REGISTER_FORM,
  PASSWORD_RULES,
  USERNAME_RULES,
  VALIDATION_MESSAGES,
  validatePassword,
  validateUsername,
  isValidEmail,
  getRegisterErrorMessage,
  // Utils
  getRandomPoints,
  getSuccessMessage,
  sortQuestionsById,
  sortPageQuestions,
  extractYouTubeId,
  // Service factories
  createScoreService,
  createGameSessionService,
  createUserAnswerService,
};
